/**
 * Header event models (menu / producer side).
 * Duplicated from app header events — no import from the header module.
 * Source: apps/kala-mobile/src/app/components/header/events/header-events.model.ts
 */

export interface HeaderConfigurationToHeader {
	visible?: boolean;
	showLogo?: boolean;
	title?: string;
}

export const MENU_HEADER_EVENTS = {
	HEADER_CONFIGURATION: 'header.configuration'
} as const;
